import type { PeSessionView } from "./api";

/** How long a session lasted: "<1m", "45m", "3h 12m", "2d 4h". */
export function fmtSpan(ms: number): string {
  const m = Math.floor(ms / 60_000);
  if (m < 1) return "<1m";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return m % 60 ? `${h}h ${m % 60}m` : `${h}h`;
  const d = Math.floor(h / 24);
  return h % 24 ? `${d}d ${h % 24}h` : `${d}d`;
}

/** Why the PE app ended a session (its `revokedReason`), in words. */
const ENDED: Record<string, string> = {
  logout: "Logged out",
  "idp-backchannel-logout": "Logged out of SSO",
  "idp-session-ended": "SSO session ended",
  "token-version": "Signed out: access changed",
  "user-inactive": "Signed out: account deactivated",
  revoked: "Signed out everywhere",
  "refresh-token-replay": "Ended: sign-in token reused",
};

export function howItEnded(s: Pick<PeSessionView, "state" | "endReason">): string {
  if (s.state === "online") return "Online now";
  if (s.state === "closed") return "Closed without logging out";
  return (s.endReason && ENDED[s.endReason]) ?? `Ended (${s.endReason ?? "no reason given"})`;
}

export const METHOD: Record<string, string> = {
  password: "Password",
  sso: "SSO",
  "break-glass": "Break-glass",
};

/** "Thu 30 Oct" in the viewer's time zone. */
export const dayOf = (iso: string) =>
  new Date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });

/** "15:04" in the viewer's time zone. */
export const timeOf = (iso: string) =>
  new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
